module.exports = __webpack_public_path__ + "img/genswell_1_1.ccf7f4c9.png";